import request from '@/utils/request'

// 获取充值页面渲染数据
export function getFloorData (data) {
  return request({
    url: '/group/audiovisualGames/productPage/showProductPage.do',
    method: 'get',
    params: { ...data }
  })
}

// 获取fulu产品信息
export function getFuluGoodsInfo (params) {
  return request({
    url: '/fulu/queryFuluProd.do',
    method: 'post',
    data: params
  })
}

// 获取goodsId
export function getGoodsId (params) {
  return request({
    url: '/group/audiovisualGames/productPage/getCouponId.do',
    method: 'post',
    data: params
  })
}

// 充值接口
export function createVirtualOrder (params) {
  return request({
    url: '/group/audiovisualGames/productPage/createAudiovisualGamesOrder.do',
    method: 'post',
    data: params
  })
}
// 获取抽奖列表
export function getPrizeList (params) {
  return request({
    url: '/activity/getActivityAwardList.do',
    method: 'post',
    data: params
  })
}

// 获取抽奖物流信息
export function getExpressMessage (params) {
  return request({
    url: '/activity/getExpressMessage.do',
    method: 'post',
    data: params
  })
}

// 获取视听文娱历史账号接口
export function mediaGetHistoryAccount (params) {
  return request({
    url: '/group/audiovisualGames/productPage/getHistoryAccount.do',
    method: 'post',
    data: params
  })
}
